import React, { useState } from 'react';
import { LineChartWidgetProps } from '../../../services/Main/types.Component';
import getMinHeight from '../DonutChartWidget/helpers/getMinHeight';
import LineChartWidget from './LineChartWidget';
import useWidgetDataQuery, {
  checkEmptyStateFn,
} from '../../../utils/hooks/useWidgetDataQuery';
import { LineChartState } from './types';
import WidgetContainer from '../../lowLevel/WidgetContainer';
import WidgetSkeletonContainer from '../../lowLevel/WidgetSkeletonContainer';
import ChartSkeleton from '../../../svg/skeletons/ChartSkeleton';
import Legend from './Legend';

const checkEmptyState: checkEmptyStateFn<LineChartState> = (payload) => {
  return (
    payload.data.length === 0 ||
    !Array.isArray(payload.data) ||
    payload.lines.length === 0 ||
    !Array.isArray(payload.lines)
  );
};

const LineChartWidgetDataLoader = (props: LineChartWidgetProps) => {
  const { heading, showLegend, requestConfig } = props;

  const height = getMinHeight(300, !!heading, true);

  const { isFetching, isFistTimeFetched, widgetState, alert } =
    useWidgetDataQuery<LineChartState>(requestConfig, checkEmptyState);

  const skeleton = (
    <ChartSkeleton
      className={!isFistTimeFetched ? 'animate-flicker' : undefined}
    />
  );

  const [hiddenLineKeys, setHiddenLineKeys] = useState<string[]>([]);

  const { footer, content } = (() => {
    if (!isFistTimeFetched)
      return {
        footer: null,
        content: <WidgetSkeletonContainer skeleton={skeleton} />,
      };

    // Информация для пользователя, если данные запросили некорректно.
    if (alert)
      return {
        footer: null,
        content: <WidgetSkeletonContainer skeleton={skeleton} alert={alert} />,
      };

    if (!widgetState) throw new Error('Неизвестная ошибка');

    return {
      footer: showLegend ? (
        <Legend
          {...widgetState}
          hiddenLineKeys={hiddenLineKeys}
          setHiddenLineKeys={setHiddenLineKeys}
        />
      ) : null,
      content: (
        <LineChartWidget
          {...props}
          {...widgetState}
          hiddenLineKeys={hiddenLineKeys}
        />
      ),
    };
  })();

  return (
    <WidgetContainer
      style={{ height }}
      showLoader={isFetching}
      heading={heading}
      footer={footer}
    >
      {content}
    </WidgetContainer>
  );
};

export default LineChartWidgetDataLoader;
